import posthog from 'posthog-js'
import tracking from '@astuteo/ph-enhancer';


// Configuration object that can be set from the environment or other sources
const config = {
    posthogKey: 'phc_UbCxbU3JJdPx4zqOXuwG8dwOj5BpQaj6fkJmbu7QAVq',
    posthogHost: 'https://lego.americanglassgallery.com',
    authKey: 'ScEJSwXZya'
};

posthog.init(config.posthogKey,
    {
        api_host: config.posthogHost,
        defaults: '2025-05-24',
        person_profiles: 'always',
        bootstrap: false
    }
)

tracking.init({
    authKey: config.authKey
});


window.tracking = tracking;
